import { render, staticRenderFns } from "./ChatHero.vue?vue&type=template&id=21ec86ab&scoped=true"
import script from "./ChatHero.vue?vue&type=script&lang=js"
export * from "./ChatHero.vue?vue&type=script&lang=js"
import style0 from "./ChatHero.vue?vue&type=style&index=0&id=21ec86ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ec86ab",
  null
  
)

export default component.exports